import Vue from 'vue'
import Router from 'vue-router'
import Details from './views/details'

Vue.use(Router)
const routes = [
  {
    path: '/',
    redirect: '/details',
    name: 'details',
    component: Details
  },
  {
    path: '/details',
    name: 'details',
    component: Details,
    meta: { title: '我正在参加美森购课团购，课程超优惠，快来和我一起拼' }
  }
]
const router = new Router({
  routes: routes
})
router.beforeEach((to, from, next) => { // beforeEach 是 router 的钩子函数，在进入路由前执行
  if (to.meta.title) { // 判断是否有标题
    document.title = to.meta.title
  }
  next() // 这个一定不能忘了！不然路由不会跳转的！
})

export default router
